import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonCheckbox, IonItem, IonLabel, IonListHeader } from '@ionic/angular/standalone';
import { ChannelCheckboxViewModel, ChannelData } from 'src/app/models/channel.model';

@Component({
  selector: 'app-channel-checkbox-list',
  templateUrl: './channel-checkbox-list.component.html',
  styleUrls: ['./channel-checkbox-list.component.scss'],
  imports: [FormsModule, IonListHeader, IonItem, IonCheckbox, IonLabel]
})
export class ChannelCheckboxListComponent implements OnInit {
  @Input() headerText: string;
  @Input() channels: ChannelCheckboxViewModel[] = [];
  @Input() selectedChannels: ChannelData[] = [];
  @Input() listDisabled: boolean;
  @Input() allSelected: boolean;
  @Output() selectedChannelsUpdate = new EventEmitter<ChannelData[]>();

  ngOnInit(): void {
    if (this.selectedChannels.length === this.channels.length) {
      this.allSelected = true;
    }
  }

  onSelectAll(): void {
    setTimeout(() => {
      this.channels.forEach(channel => (channel.checked = this.allSelected));
      this.selectionChanged();
    });
  }

  selectionChanged(): void {
    const totalItems = this.channels.length;
    let checked = 0;
    this.channels.map((channel) => {
      if (channel.checked) {
        checked++;

        if (this.selectedChannels.findIndex(channelData => channelData.channelId === channel.id) === -1) {
          this.selectedChannels.push({
            channelId: channel.id,
            subscribe: !channel.subscribed
          });
        }
      } else {
        this.selectedChannels = this.selectedChannels.filter(
          selectedChannel => selectedChannel.channelId !== channel.id
        );
      }
    });

    if (checked > 0 && checked < totalItems) {
      this.allSelected = false;
    } else if (checked === totalItems) {
      this.allSelected = true;
    } else {
      this.allSelected = false;
    }

    this.selectedChannelsUpdate.emit(this.selectedChannels);
  }
}
